const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userId: state => state.user.userId,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  setting: state => state.user.setting,
  email: state => state.user.email,
  defaultbranch: state => state.user.defaultbranch,
  getPagination: state => state.user.paginationObject,
  personalInfo: state => state.user.personalInfo
};
export default getters;
